module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "pl10px pr10px",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('table', {
    staticClass: "table mb0px table-striped table-bordered"
  }, [_c('thead', [_vm._m(0), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.theadList), function(thead) {
    return _c('th', [_vm._v(_vm._s(thead))])
  }), _vm._v(" "), _c('th')], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.orgList), function(fileInfo, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [(fileInfo.isenable == 1) ? _c('a', {
      style: ({
        color: fileInfo.mainFlag === 1 ? '#d9534f' : '#337ab7'
      }),
      on: {
        "click": function($event) {
          return _vm.setMaster(fileInfo.mainFlag, fileInfo.id)
        }
      }
    }, [_vm._v(_vm._s(fileInfo.mainFlag === 1 ? '主设备' : '设为主设备'))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("VD" + _vm._s(fileInfo.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.deviceNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.brandName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.categoryName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.obdFlagName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.wifiFlagName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.simNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.activeDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.payPeriodName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.paymentModeName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.installer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.installDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.installTypeName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(fileInfo.isenable == 0) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.removeDevice(fileInfo.id, fileInfo.isEnable)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("设备基本信息")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("SIM卡信息")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("设备安装信息")]), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dd87000","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/carfile/detail/DetailDevice.vue
// module id = 1461
// module chunks = 0